import React, { useState, useEffect } from "react";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";

const PlaceComponent = ({ value, onChange, field, label, error }) => {
  const [address, setAddress] = useState(value || "");

  const handleSelect = async (selected) => {
    try {
      const results = await geocodeByAddress(selected);
      if (results && results[0]) {
        const components = results[0].address_components;

        const getComponent = (type) => {
          const comp = components.find((c) => c.types.includes(type));
          return comp ? comp.long_name : "";
        };

        const streetNumber = getComponent("street_number");
        const streetName = getComponent("route");
        const city = getComponent("locality");
        const state = getComponent("administrative_area_level_1");
        const zip = getComponent("postal_code");
        const country = getComponent("country");

        const formatted = `${streetNumber} ${streetName}, ${city}, ${state}${
          zip ? " " + zip : ""
        }${country ? ", " + country : ""}`;

        setAddress(formatted);
        onChange(field, formatted);
      }
    } catch (err) {
      console.error("Error fetching place details:", err);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const input = document.querySelector(".pac-target-input");
      if (input) {
        input.setAttribute("placeholder", "");

        const observer = new MutationObserver(() => {
          input.setAttribute("placeholder", "");
        });
        observer.observe(input, {
          attributes: true,
          attributeFilter: ["placeholder"],
        });

        clearInterval(interval);
      }
    }, 100);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="place-wrapper">
      <label className="form-label">
        {label}
        <span className="text-danger">*</span>
      </label>
      <PlacesAutocomplete
        value={address}
        onChange={setAddress}
        onSelect={handleSelect}
        debounce={300}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
          <div className="autocomplete-root">
            <input
              {...getInputProps({
                placeholder: "",
                className: "form-control",
              })}
            />

            {(loading || suggestions.length > 0) && (
              <div className="autocomplete-dropdown">
                {loading && <div className="suggestion-item">Loading...</div>}

                {suggestions.map((suggestion) => {
                  const className = suggestion.active
                    ? "suggestion-item active"
                    : "suggestion-item";
                  return (
                    <div
                      {...getSuggestionItemProps(suggestion, { className })}
                      key={suggestion.placeId}
                    >
                      {suggestion.description}
                    </div>
                  );
                })}
              </div>
            )}
            {error && <div className="text-danger mt-1">{error}</div>}
          </div>
        )}
      </PlacesAutocomplete>
    </div>
  );
};

export default PlaceComponent;
